<template>
  <ShortcutPage :release="release"></ShortcutPage>
</template>
<script>
import ShortcutPage from './ShortcutPage'

export default {
  name: 'SoyezSages',
  data: function() {
    return { release: null }
  },
  components: {
    ShortcutPage,
  },
  mounted: function () {
    this.release = {
      img: '/img/single-soyezsages.png',
      name: 'Soyez sages',
      type: 'single',
      links: [
        {
          service: 'bandcamp',
          url: 'https://grizzlycogs.bandcamp.com/track/soyez-sages-single',
          btnLabel: 'Listen'
        },
        {
          service: 'spotify',
          url: 'https://open.spotify.com/intl-fr/album/1KHAtj6FXpE2LzItI1u1zU?si=dc5M12FsQcq-BDQHreMv-g',
          btnLabel: 'Listen'
        },
        {
          service: 'youtube',
          url: 'https://www.youtube.com/watch?v=8bmejEQrXeI',
          btnLabel: 'Listen'
        },
        {
          service: 'deezer',
          url: 'https://www.deezer.com/fr/album/1015054051',
          btnLabel: 'Listen'
        },
        {
          service: 'apple',
          url: 'https://music.apple.com/fr/album/soyez-sages-single/6785048435',
          btnLabel: 'Listen'
        },
        {
          service: 'amazon',
          url: 'https://music.amazon.com/albums/B0H6Q6SH68?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_eLifS6gOqr7Av4W1B9u8S2skm',
          btnLabel: 'Buy'
        },
        {
          service: 'tidal',
          url: 'https://tidal.com/album/537133796',
          btnLabel: 'Listen'
        }
      ]
    }
  }
}
</script>